export default {
  toolbar: {
    '@media (min-width:0px) and (orientation: landscape)': { minHeight: 60 },
    '@media (min-width:600px)': { minHeight: 60 },
    minHeight: 60,
  },
};
